package com.eladfinish.bible.contest.ui.scaffold

enum class MessageKind {
    TOAST,
    SNACKBAR,
    LOADING,
}
